import { SubcontractorRequestStatus } from './enum'

export const subcontractorRequestStatusTitles = {
  [SubcontractorRequestStatus.Active]: 'Active',
  [SubcontractorRequestStatus.Inactive]: 'Deactivated',
  [SubcontractorRequestStatus.PendingCustomerReview]: 'Waiting for Approval',
  [SubcontractorRequestStatus.Rejected]: 'Rejected',
}
